"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _compose = _interopRequireDefault(require("recompose/compose"));

var _withPropsOnChange = _interopRequireDefault(require("recompose/withPropsOnChange"));

var _pure = _interopRequireDefault(require("recompose/pure"));

var _ChartTooltip = _interopRequireDefault(require("../ChartTooltip"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const BarItem = ({
  data,
  x,
  y,
  width,
  height,
  borderRadius,
  color,
  borderWidth,
  borderColor,
  label,
  shouldRenderLabel,
  labelColor,
  showTooltip,
  hideTooltip,
  onClick,
  onMouseEnter,
  onMouseLeave,
  tooltip,
  theme
}) => {
  const handleTooltip = e => showTooltip(tooltip, e);

  const handleMouseEnter = e => {
    onMouseEnter(data, e);
    showTooltip(tooltip, e);
  };

  const handleMouseLeave = e => {
    onMouseLeave(data, e);
    hideTooltip(e);
  };

  return _react.default.createElement("g", {
    transform: "translate(" + x + ", " + y + ")"
  }, _react.default.createElement("rect", {
    width: width,
    height: height,
    rx: borderRadius,
    ry: borderRadius,
    fill: data.fill ? data.fill : color,
    strokeWidth: borderWidth,
    stroke: borderColor,
    onMouseEnter: handleMouseEnter,
    onMouseMove: handleTooltip,
    onMouseLeave: handleMouseLeave,
    onClick: onClick
  }), shouldRenderLabel && _react.default.createElement("text", {
    x: width / 2,
    y: height / 2,
    textAnchor: "middle",
    dominantBaseline: "central",
    style: _extends({}, theme.labels.text, {
      pointerEvents: 'none',
      fill: labelColor
    })
  }, label));
};

BarItem.propTypes = process.env.NODE_ENV !== "production" ? {
  data: _propTypes.default.shape({
    id: _propTypes.default.string.isRequired,
    value: _propTypes.default.number.isRequired,
    indexValue: _propTypes.default.string.isRequired
  }).isRequired,
  x: _propTypes.default.number.isRequired,
  y: _propTypes.default.number.isRequired,
  width: _propTypes.default.number.isRequired,
  height: _propTypes.default.number.isRequired,
  color: _propTypes.default.string.isRequired,
  borderRadius: _propTypes.default.number.isRequired,
  borderWidth: _propTypes.default.number.isRequired,
  borderColor: _propTypes.default.string.isRequired,
  label: _propTypes.default.node.isRequired,
  shouldRenderLabel: _propTypes.default.bool.isRequired,
  labelColor: _propTypes.default.string.isRequired,
  showTooltip: _propTypes.default.func.isRequired,
  hideTooltip: _propTypes.default.func.isRequired,
  getTooltipLabel: _propTypes.default.func.isRequired,
  tooltipFormat: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  onClick: _propTypes.default.func,
  onMouseEnter: _propTypes.default.func,
  onMouseLeave: _propTypes.default.func,
  tooltip: _propTypes.default.element.isRequired,
  theme: _propTypes.default.shape({
    tooltip: _propTypes.default.shape({}).isRequired
  }).isRequired
} : {};
const enhance = (0, _compose.default)((0, _withPropsOnChange.default)(['data', 'color', 'onClick'], ({
  data,
  color,
  onClick: _onClick
}) => ({
  onClick: event => _onClick(_extends({
    color
  }, data), event)
})), (0, _withPropsOnChange.default)(['data', 'color', 'theme', 'tooltip', 'getTooltipLabel', 'tooltipFormat'], ({
  data,
  color,
  theme,
  tooltip,
  getTooltipLabel,
  tooltipFormat
}) => ({
  tooltip: _react.default.createElement(_ChartTooltip.default, {
    id: getTooltipLabel(data),
    value: data.value,
    enableChip: true,
    color: color,
    theme: theme,
    format: tooltipFormat,
    renderContent: typeof tooltip === 'function' ? tooltip.bind(null, _extends({
      color,
      theme
    }, data)) : null
  })
})), _pure.default);

var _default = enhance(BarItem);

exports.default = _default;
module.exports = exports.default;